import { Tab, TabGroup } from '@nike/eds'
import { useState } from 'react'
import { ShipmentDetails } from './ShipmentDetails'
import { ShipmentRebookings } from './ShipmentRebookings'

export function ShipmentDetailsTabs({ shipment }) {
  const [activeTab, setActiveTab] = useState('tab-shipment-details')
  return (
    <div>
      <TabGroup
        name="tab-group"
        activeId={activeTab}
        onChange={(e) => setActiveTab(e.target.id)}
        className="table-title"
      >
        <Tab id="tab-shipment-details" className="eds-type--title-3">
          Shipment Details
        </Tab>
        <Tab id="tab-shipment-rebookings" className="eds-type--title-3">
          Rebooking Info
        </Tab>
      </TabGroup>
      {activeTab === 'tab-shipment-details' && <ShipmentDetails shipment={shipment} />}
      {activeTab === 'tab-shipment-rebookings' && <ShipmentRebookings shipment={shipment} />}
    </div>
  )
}
